import actions from './actions';
import initialState from '../initialState';

export const borrowerReducer = (state = initialState.borrower, action) => {
    switch (action.type) {
        case actions.EDIT_ENTITY_MODAL:
            return { ...state, editEntityModal: action.state.editEntityModal };
        case actions.EDIT_ENTITY_CONTACT_LINK:
            return { ...state, editBorrowerEntityToPrincipalLinkModal: action.state.editBorrowerEntityToPrincipalLinkModal };
        case actions.EDIT_PRINCIPAL_MODAL:
            return {
                ...state,
                editPrincipalModal: action.state.editPrincipalModal,
            };
        case actions.DELETE_ENTITY_CONTACT_LINK:
            return { 
                ...state, 
                deleteBorrowerEntityToPrincipalLinkModal: action.state.deleteBorrowerEntityToPrincipalLinkModal 
            };
        case actions.DELETE_COMPANY_CONTACT_LINK_MODAL:
            return {
                ...state, 
                deleteBusinessToPrincipalLinkModal: action.state.deleteBusinessToPrincipalLinkModal 
            };
        case actions.EDIT_COMPANY_MODAL:
            return {
                ...state,
                editCompanyModal: action.state.editCompanyModal,
            };
        case actions.DELETE_FOREVER_MODAL:
            return {
                ...state,
                deleteForeverModal: action.state.deleteForeverModal,
            };
        case actions.RECYCLE_BIN_MODAL:
            return { ...state, recycleBinModal: action.state.recycleBinModal };
        case actions.ENTITY_AUDIT_HISTORY_MODAL:
            return {
                ...state,
                entityAuditHistoryModal: action.state.entityAuditHistoryModal,
            };
        default:
            return { ...state };
    }
};

export default borrowerReducer;
